// Firebase Configuration
// 統合認証基盤 - cp-integratedauthentication プロジェクト

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase プロジェクト設定（cp-integratedauthentication）
const firebaseConfig = {
  apiKey: "AIzaSyCniK3-QXUzpDgMEGjCNqglhlwwQOgQuTc",
  authDomain: "cp-integratedauthentication.firebaseapp.com",
  projectId: "cp-integratedauthentication",
  storageBucket: "cp-integratedauthentication.firebasestorage.app",
  messagingSenderId: "738990389061",
  appId: "1:738990389061:web:d500359c152fc5243ff02c",
  measurementId: "G-CYY80LV152"
};

// 単一のFirebaseアプリインスタンス
const app = initializeApp(firebaseConfig);

// 認証・Firestore・Storage は同じアプリインスタンスから取得
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// 後方互換性のためのエイリアス
const authHubApp = app;
const dataApp = app;
const authHubAuth = auth;

export { app, authHubApp, dataApp, authHubAuth, auth, db, storage };
export default app;
